<button
  class="client-name"
  [ngClass]="{'rounded': isClientSelect, 'half-rounded': !isClientSelect}"
  [name]="selectedClient.name"
>
  <img [src]="imageURI" [alt]="selectedClient.name" />
  <div class="dropdown-arrow"></div>
</button>
